var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-center px-4 py-2 md:p-0"},[_c('router-link',{staticClass:"inline-block rounded-full bg-white px-4 py-2 text-sm font-semibold text-ink transition-colors hover:bg-white/90",attrs:{"to":_vm.$i18nRoute({ name: 'NewsroomRegister' })}},[_vm._v(" "+_vm._s(_vm.$t('components.top_nav.free_newsroom'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }